var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "picker passenger-picker" },
    [
      _c(
        "input-button",
        {
          class:
            "rounded passenger-picker-btn" +
            (_vm.passengerError !== null || _vm.railcardsRequired === -1
              ? " error"
              : ""),
          attrs: { type: "outline", icon: "none" },
          on: {
            click: _vm.showPassengerPicker,
            "click-inner": _vm.didClickAuxiliary,
          },
        },
        [
          _c("span", [_vm._v("\n            " + _vm._s(_vm.buttonText))]),
          _c("font-awesome-icon", {
            staticClass: "ml-1",
            attrs: {
              icon:
                "fa-solid " + (_vm.isOpen ? "fa-caret-up" : "fa-caret-down"),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c("div", { staticClass: "block-ui", on: { click: _vm.closePicker } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen",
          },
        ],
        staticClass: "background-blocker show-when-modal",
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "picker-dropdown rounded shadow",
        },
        [
          _c(
            "div",
            { staticClass: "dropdown-header show-when-modal" },
            [_vm._t("default", [_vm._v("Passengers")])],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "passenger-picker" },
            [
              _vm.modifiedOptions
                ? _c("options-group", {
                    attrs: { config: _vm.passengerOptionsConfig },
                    on: { input: _vm.validate },
                    model: {
                      value: _vm.modifiedOptions,
                      callback: function ($$v) {
                        _vm.modifiedOptions = $$v
                      },
                      expression: "modifiedOptions",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "action-buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.closePicker },
              },
              [_vm._v("\n                Close\n            ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }